import { makeAutoObservable } from "mobx";

export default class PoolStore {
    constructor() {
        this._pools = [];
        this._poolitems = [];
        this._poolitemsforthispool = [];
        this._currentuserpools = [];
        this._currentuserpoolitems = [];
        this._selectedPool = {};
        this._selectedPoolItem = {};

        this._page = 1;
        this._totalCount = 192;
        this._limit = 24;
        this._loading = false; // Для состояния загрузки

        makeAutoObservable(this);
    }

    // Сеттеры
    setPools(pools) {
        this._pools = pools;
    }

    setPoolItems(poolitems) {
        this._poolitems = poolitems;
    }

    setPoolItemsForThisPool(poolitems) {
        this._poolitemsforthispool = poolitems;
    }

    setCurrentUserPools(currentuserpools) {
        this._currentuserpools = currentuserpools;
    }

    setCurrentUserPoolItems(currentuserpoolitems) {
        this._currentuserpoolitems = currentuserpoolitems;
    }

    setSelectedPool(pool) {
        this._selectedPool = pool;
    }

    setSelectedPoolItem(poolItem) {
        this._selectedPoolItem = poolItem;
    }

    setPollPage(page) {
        this._page = page;
    }

    setTotalCount(count) {
        this._totalCount = count;
    }

    setPollLimit(limit) {
        this._limit = limit;
    }

    setLoading(bool) {
        this._loading = bool;
    }

    // Геттеры
    get pools() {
        return this._pools;
    }

    get poolitems() {
        return this._poolitems;
    }

    get poolitemsForThisPool() {
        return this._poolitemsforthispool;
    }

    get currentUserPools() {
        return this._currentuserpools;
    }

    get currentUserPoolItems() {
        return this._currentuserpoolitems;
    }

    get selectedPool() {
        return this._selectedPool;
    }

    get selectedPoolItem() {
        return this._selectedPoolItem;
    }

    get pollPage() {
        return this._page;
    }

    get totalCount() {
        return this._totalCount;
    }

    get pollLimit() {
        return this._limit;
    }

    get loading() {
        return this._loading;
    }
}
